import Glide from "@glidejs/glide";

class BannerCarousel {
    constructor() {
        this.carousel = ".js-banner-carousel";
    }

    setupBannerCarousel() {
        const carousels = Array.from(document.querySelectorAll(this.carousel));

        if (carousels.length > 0) {
            carousels.forEach(carousel => {
                new Glide(carousel, {
                    classes: {
                        direction: {
                            ltr: "carousel--ltr",
                            rtl: "carousel--rtl",
                        },
                        base: "carousel",
                        wrapper: "carousel__wrapper",
                        track: "carousel__track",
                        slide: "carousel__slide",
                        slider: "carousel__slider",
                        carousel: "carousel__carousel",
                        swipeable: "carousel--swipeable",
                        dragging: "carousel--dragging",
                        cloneSlide: "carousel__slide--clone",
                        activeSlide: "carousel__slide--active",
                        arrows: "carousel__arrows",
                        arrow: "carousel__arrow",
                    },
                    autoplay: 3000,
                }).mount();
            });
        }
    }

    init() {
        this.setupBannerCarousel();
    }
}

export default BannerCarousel;



// WEBPACK FOOTER //
// ../project/craft/src/components/banners/banners.js